<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content>
  <p>{{ message }}</p>
  <mat-checkbox [(ngModel)]="confirmed">{{ checkboxLabel }}</mat-checkbox>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Indietro</button>
  <button mat-raised-button color="primary" [disabled]="!confirmed" (click)="confirm()">
    <mat-icon>check</mat-icon>
      Confermo
    </button>
</mat-dialog-actions>
